import Fuse from 'fuse.js';
import React, { useCallback, useEffect, useState } from 'react';
import { useSessionStorage } from 'react-use';
import { ObjectManager } from '../../../concepts/objects';
import { Input } from '../../../ui';
import { useResolve } from '../../Container';
import { Flexer, Spacer } from '../../dashboard/elements/LayoutElements';
import { HistoryItem, HistoryManager } from '../history/HistoryManager';

export const DeveloperHistoryInfo = () => {

    const objects = useResolve(ObjectManager);
    const [filter, setFilter] = useSessionStorage('deqo/ui/developer/model/filter', '');
    const from = useCallback((state: Record<string, any>) => {
        const keys = Object.keys(state);
        const filtered = !!filter
            ? new Fuse(keys, { includeScore: true }).search(filter).filter(x => x.score < 0.1).map(x => x.item)
            : keys;
        return filtered.sort();
    }, [filter]);

    const history = useResolve(HistoryManager);

    const [items, setItems] = useState([] as HistoryItem[]);

    useEffect(() => {
        const sync = () => setItems([
            ...Array.from(history.pastItems),
            ...(history.nextItem ? [history.nextItem] : []),
        ]);
        sync();
        return history.on('updated', sync);
    }, []);


    return <>
        <Input placeholder="Filter" value={filter} onChange={setFilter} autoFocus />
        <Spacer f={2} />
        <Flexer>
            {items.map(x =>
                <Flexer key={x.id}>
                    {x.label}
                </Flexer>
            )}
        </Flexer>
    </>;
};
